var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4C0 28.9933 2.96 32 6.6 32H25.4067C29.0467 31.9933 32 29.04 32.0067 25.4V6.6C32.0067 3.00667 29.0467 0 25.4067 0H6.6C3 0 0 2.96 0 6.6V25.4067V25.4Z",
    fill: "#1ED760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.37333 4 4 9.37333 4 16C4 22.6267 9.37333 28 16 28C22.6267 28 28 22.6267 28 16C28 9.37333 22.6267 4 16 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 21.3067C21.2864 21.66 20.8264 21.7734 20.4731 21.5534C17.6531 19.8334 14.1064 19.44 9.93307 20.4C9.53307 20.4934 9.1264 20.24 9.03974 19.84C8.9464 19.44 9.19974 19.0334 9.59974 18.9467C14.1731 17.9 18.0931 18.3534 21.2531 20.2867C21.6064 20.5 21.7197 20.96 21.4997 21.3134V21.3067ZM22.9731 18.04C22.6997 18.48 22.1264 18.62 21.6864 18.3467C18.4597 16.3667 13.5464 15.7867 9.7264 16.9467C9.23307 17.0934 8.7064 16.82 8.55974 16.3267C8.41307 15.8334 8.6864 15.3134 9.1864 15.16C13.5464 13.84 18.9597 14.48 22.6664 16.7534C23.1064 17.0267 23.2464 17.6 22.9731 18.04ZM23.0997 14.64C19.2331 12.34 12.8531 12.1334 9.15974 13.2534C8.5664 13.4334 7.93974 13.1 7.75974 12.5067C7.57974 11.9134 7.91307 11.2867 8.5064 11.1067C12.7464 9.82003 19.7931 10.0667 24.2464 12.7134C24.7797 13.0267 24.9531 13.72 24.6397 14.2534C24.3264 14.7867 23.6331 14.96 23.0997 14.6467V14.64Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/SPOTIFY.e1e14dced991683378cdd48be3773a31.svg";
export { ForwardRef as ReactComponent };